// export const clientId = 'c658ef3ecc1b4272bb4964a3b6c87595';
// export const redirectUri = 'http://localhost:3000';
export const clientId = '2647d23200344184ac2113a383021eb9';
export const redirectUri = 'https://filter.mattlongpre.com/';